import type { RouteRecordRaw, Router } from 'vue-router'
import { MODULE_ACCESS } from '@/modules/Core/constants/adminAccess'

const OrderRoutes: RouteRecordRaw = {
  path: '/order',
  name: 'OrderModulePages',
  redirect: { name: '' },
  children: [
    {
      path: '',
      name: 'ManageOrderRoute',
      component: () => import('./views/ManageOrderView.vue'),
      meta: {
        title: 'سفارشات',
      },
    },
    {
      path: 'view/:orderId',
      name: 'ViewOrderRoute',
      component: () => import('./views/OrderDetailsView.vue'),
      meta: {
        title: 'جزئیات سفارش',
        pageHasBack: true,
      },
    },
  ],
  meta: {
    layout: 'Default',
    allowedRoles: MODULE_ACCESS.order,
  },
}

export default (router: Router) => {
  router.addRoute(OrderRoutes)
}
